import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { getMappedSignerData } from "mappers";
import { creditReviewDetailsService } from "services";
import { uiActions } from "store";
import { ExecutiveSignerDto, ErrorResponse } from "types";

type useGetExecutiveSummaryQueryProps = {
	creditReviewId: string;
};

const useGetExecutiveSignerQuery = ({
	creditReviewId,
}: useGetExecutiveSummaryQueryProps) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["executiveSignerInfo", creditReviewId],
		() =>
			creditReviewDetailsService.getExecutiveSignerInfo({
				creditReviewId,
			}),
		{
			select: (data: ExecutiveSignerDto) => {
				return getMappedSignerData(data);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!creditReviewId,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetExecutiveSignerQuery;
